import {
  CategorySummaryResponse,
  DeploymentSummaryStats,
  ProjectAnalyticsResponse,
  RuleAnalyticsResponse,
  RulesEventType,
  TimeLookbackRange,
  TIME_LOOKBACK_RANGES_TO_DAYS_AGO,
} from "./types";
import { authGet } from "../../auth/auth";
import moment from "moment";

const RULES_PAGE_SIZE = 5;

export const calculateLookbackSeconds = (tlr: TimeLookbackRange) => {
  const daysAgo = TIME_LOOKBACK_RANGES_TO_DAYS_AGO[tlr];
  return daysAgo === Infinity ? 0 : moment().subtract(daysAgo, "days").unix();
};

export const fetchDeploymentSummaryStats = (
  deploymentId: string,
  timeLookbackRange: TimeLookbackRange,
  until: number = moment().unix()
): Promise<DeploymentSummaryStats> => {
  const since = calculateLookbackSeconds(timeLookbackRange);
  return authGet<DeploymentSummaryStats>(
    `/api/agent/deployments/${deploymentId}/analytics/summary?since=${since}&until=${until}`
  );
};

export const fetchCategorySummaries = (
  deploymentId: string,
  timeLookbackRange: TimeLookbackRange,
  until: number = moment().unix()
): Promise<CategorySummaryResponse> => {
  const since = calculateLookbackSeconds(timeLookbackRange);
  return authGet<CategorySummaryResponse>(
    `/api/agent/deployments/${deploymentId}/analytics/categories?since=${since}&until=${until}`
  );
};

export const fetchProjectStats = (
  deploymentId: string,
  timeLookbackRange: TimeLookbackRange,
  until: number = moment().unix()
): Promise<ProjectAnalyticsResponse> => {
  const since = calculateLookbackSeconds(timeLookbackRange);
  return authGet<ProjectAnalyticsResponse>(
    `/api/agent/deployments/${deploymentId}/analytics/projects?since=${since}&until=${until}`
  );
};

export const fetchRuleStats = (
  deploymentId: string,
  eventType: RulesEventType,
  timeLookbackRange: TimeLookbackRange,
  until: number = moment().unix(),
  limit: number = RULES_PAGE_SIZE
): Promise<RuleAnalyticsResponse> => {
  const since = calculateLookbackSeconds(timeLookbackRange);
  return authGet<RuleAnalyticsResponse>(
    `/api/agent/deployments/${deploymentId}/analytics/rules?event=${eventType}&since=${since}&until=${until}&limit=${limit}`
  );
};
